export default __webpack_public_path__ + "static/media/bsc.d40b7144.png";